import { render, staticRenderFns } from "./email-dialog.vue?vue&type=template&id=412987fe&scoped=true&"
import script from "./email-dialog.vue?vue&type=script&lang=js&"
export * from "./email-dialog.vue?vue&type=script&lang=js&"
import style0 from "./email-dialog.vue?vue&type=style&index=0&id=412987fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412987fe",
  null
  
)

export default component.exports